import React from "react";
import {Container} from "semantic-ui-react";
import OperationTypesList from "../../../components/torres/operation-type-components/operation-types-list";

const OperationTypePage = () => {

    return (
        <Container style={{padding: "20px"}}>
            <OperationTypesList/>
        </Container>
    );
};

export default OperationTypePage;
